/**
 *
 * Asynchronously loads the component for ResetPassword
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
